import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../AuthContext';
import apiClient from '../../api/apiClient';

const AddProduct = () => {
  const navigate = useNavigate();
  const {isAuthenticated } = useContext(AuthContext);
  const [product, setProduct] = useState({
    title: '',
    description: '',
    imageUrls: [],
    affiliateLink: '',
    brand: '',
    category: '',
    platform: '',
    price: '',
    originalPrice: '',
    active: true,
  });

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/admin-login');
    } 
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProduct(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert imageUrls from string to array
    const payload = {
      ...product,
      price: parseFloat(product.price),
      originalPrice: parseFloat(product.originalPrice),
      imageUrls: product.imageUrls.split('\n').map(url => url.trim())
    };

    await apiClient.post('/admin/aff', payload);
    navigate('/affiliate');
  };

  return (
    <div className="container mt-5">
      <h2>Add New Product</h2>
      <form onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label">Title</label>
          <input type="text" className="form-control" name="title" value={product.title} onChange={handleChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Description (use ||| for bullet points)</label>
          <textarea className="form-control" name="description" value={product.description} onChange={handleChange} rows="3" />
        </div>

        <div className="mb-3">
          <label className="form-label">Image URLs (one per line)</label>
          <textarea className="form-control" name="imageUrls" value={product.imageUrls} onChange={handleChange} rows="4" />
        </div>

        <div className="mb-3">
          <label className="form-label">Affiliate Link</label>
          <input type="url" className="form-control" name="affiliateLink" value={product.affiliateLink} onChange={handleChange} />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Brand</label>
            <input type="text" className="form-control" name="brand" value={product.brand} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Category</label>
            <input type="text" className="form-control" name="category" value={product.category} onChange={handleChange} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Platform</label>
            <input type="text" className="form-control" name="platform" value={product.platform} onChange={handleChange} />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Price</label>
            <input type="number" className="form-control" name="price" value={product.price} onChange={handleChange} required />
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Original Price</label>
            <input type="number" className="form-control" name="originalPrice" value={product.originalPrice} onChange={handleChange} />
          </div>
        </div>

        <div className="form-check mb-3">
          <input className="form-check-input" type="checkbox" name="active" checked={product.active} onChange={handleChange} />
          <label className="form-check-label">Active</label>
        </div>

        <button type="submit" className="btn btn-primary">Submit Product</button>
      </form>
    </div>
  );
};

export default AddProduct;
